import { reloadPage } from '@/services/page-lifecycle';
import { applyBrandFavicon } from '@/modules/brand-variant/favicon';

export async function showConfigError(error: unknown): Promise<void> {
  // eslint-disable-next-line no-console
  console.error('[config] The Shell could not load a valid env-config.json', error);

  // An unstyled message still beats a blank page when the stylesheet chunk fails too.
  await import(/* webpackChunkName: "config-error" */ './config-error-styles').catch(
    () => undefined,
  );

  const app = document.getElementById('app');
  if (!app) return;

  const title = document.createElement('h1');
  title.className = 'shell-config-error__title';
  title.textContent = 'Configuration error';

  const message = document.createElement('p');
  message.className = 'shell-config-error__message';
  message.textContent =
    "ABAX could not start because this environment's settings are missing or invalid.";

  const retry = document.createElement('button');
  retry.type = 'button';
  retry.className = 'shell-config-error__retry';
  retry.textContent = 'Retry';
  retry.addEventListener('click', () => reloadPage('retry'));

  const view = document.createElement('div');
  view.className = 'shell-config-error';
  view.setAttribute('role', 'alert');
  view.append(title, message, retry);

  // Without a valid config the host's brand is unknown; the page is ABAX throughout.
  applyBrandFavicon('abax');
  document.title = 'ABAX - Configuration error';
  app.replaceChildren(view);
}
